module.exports = __webpack_public_path__ + "img/contact_bg.4e61b7cd.jpg";